export type CurrencyLike = string | number | null | undefined;

export type PurchaseOrderSummarySource = {
  subtotal?: CurrencyLike;
  tax?: CurrencyLike;
  shippingCost?: CurrencyLike;
  totalAmount?: CurrencyLike;
};

export type PurchaseOrderSummaryItem = {
  item?: {
    amount?: CurrencyLike;
  } | null;
} | null | undefined;

export type PurchaseOrderTaxIncludedSummary = {
  subtotal: number;
  tax: number;
  shippingCost: number;
  totalAmount: number;
};

export const normalizeCurrencyNumber = (value: CurrencyLike): number => {
  const numericValue = typeof value === 'number' ? value : Number(value ?? 0);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const calculateIncludedConsumptionTax = (taxIncludedAmount: number): number => {
  if (!Number.isFinite(taxIncludedAmount) || taxIncludedAmount <= 0) {
    return 0;
  }
  return Math.round((taxIncludedAmount * 10) / 110);
};

export const calculatePurchaseOrderTaxIncludedSummary = (
  order: PurchaseOrderSummarySource,
  items: PurchaseOrderSummaryItem[] = [],
): PurchaseOrderTaxIncludedSummary => {
  const itemSubtotal = items.reduce(
    (sum, entry) => sum + normalizeCurrencyNumber(entry?.item?.amount),
    0,
  );
  const storedSubtotal = normalizeCurrencyNumber(order.subtotal);
  const subtotal = itemSubtotal > 0 ? itemSubtotal : storedSubtotal;
  const shippingCost = normalizeCurrencyNumber(order.shippingCost);

  return {
    subtotal,
    tax: calculateIncludedConsumptionTax(subtotal),
    shippingCost,
    totalAmount: subtotal + shippingCost,
  };
};

export const formatPurchaseOrderMoney = (value: CurrencyLike): string =>
  `¥${normalizeCurrencyNumber(value).toLocaleString()}`;
